module.exports = __webpack_public_path__ + "img/q_img06.a8f893cc.jpg";